import request from '../request'
import download from '../download'

export function fetchList(data) {
    return request({
        url: '/project-service/contract/list',
        method: 'post',
        data,
    })
}

export function add(data) {
    return request({
        url: '/project-service/contract/add',
        method: 'POST',
        data
    })
}

export function fetchDetail(params) {
    return request({
        url: `/project-service/contract/query/${params}`,
    })
}

export function edit(data) {
    return request({
        url: '/project-service/contract/update',
        method: 'POST',
        data
    })
}

export function remove(data) {
    return request({
        url: '/project-service/contract/del',
        method: 'POST',
        data
    })
}

// 修改合同的生产负责人
export function updateMaster(data) {
    return request({
        url: '/project-service/contract/updateMaster',
        method: 'post',
        data,
    })
}

// 下载金慧的文件
export function downloadFile(data) {
    return download({
        url: '/common-service/file/jinHuiFile',
        method: 'post',
        data,
    })
}


//跟新业主方
export function updateupdatePartyA(data) {
    return download({
        url: '/project-service/contract/updatePartyA',
        method: 'post',
        data,
    })
}

// 获取合同下的父项目信息（用于计算已确认产值金额）
export function fetchParentProject(contractId) {
    return request({
        url: `/project-service/project/firstInfo/${contractId}`,
    })
}